import React from 'react';

import bem from '../../../../utils/bem';

const [, element] = bem('applied-filters-bar');

const OrSeparator: React.FC = () => (
  <div className={element('or-separator')} data-testid="or-separator">
    <span className={element('or-separator-label')}>OR</span>
  </div>
);

export default OrSeparator;
